import { RootState } from '@reducers';

export const selectArticlePage = (state: RootState) => state.articlePageReducer;
